import { TYPE } from '../constants-vcard4'
import { VCard } from '../../../types/ParsedVCardTypes';
import { deepClone } from '../deepClone.ts';

export function filterVCardFieldsForWork(vCard: VCard[]): VCard[] {
    let filteredVCard = deepClone(vCard); // Deep copy the vCard object

    function filterCondition(field) {
        if (field && field.type) {
            // Check if the type is an array
            if (Array.isArray(field.type)) {
                // Check for the value "work" in each element of the array
                return field.type.map((v: string) => v.toLowerCase()).includes(TYPE.WORK.toLowerCase());
            }
            else if (typeof field.type === 'string') {
                // If the type is a string, check for "work" directly in the string
                return field.type.toLowerCase() === TYPE.WORK.toLowerCase();
            }
        }
        // If the field object does not have a type attribute, preserve it
        return true;
    }

    function filterFields(object) {
        Object.keys(object).forEach(key => {
            if (Array.isArray(object[key])) { // If the property is an array
                object[key] = object[key].filter(filterCondition);
                object[key].forEach(item => filterFields(item)); // Recursively filter array items
            } else if (typeof object[key] === "object" && object[key] !== null) { // If the property is an object
                if (filterCondition(object[key])) {
                    filterFields(object[key]); // Recursively filter nested object fields
                } else {
                    delete object[key]; // Delete the property if it does not meet the filter conditions
                }
            }
        });
    }

    filterFields(filteredVCard);

    return filteredVCard;
}